export default {
    cn: {
        mt4SeregatedReport: {
            downloadName: 'MT5实时盈亏报表',
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'GROUP', value: '组别' },
                { key: 'BALANCE', value: '余额' },
                { key: 'UNREALIZED', value: '实时浮动盈亏' },
                { key: 'EQUITY', value: '净值' },
            ]
        }
    },
    hk: {
        mt4SeregatedReport: {
            downloadName: 'MT5實時盈虧報表',
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'GROUP', value: '組別' },
                { key: 'BALANCE', value: '餘額' },
                { key: 'UNREALIZED', value: '實時浮動盈虧' },
                { key: 'EQUITY', value: '淨值' },
            ]
        }
    },
    en: {
        mt4SeregatedReport: {
            downloadName: 'MT5 Seregated Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'GROUP', value: 'Group' },
                { key: 'BALANCE', value: 'Balance' },
                { key: 'UNREALIZED', value: 'Unrealized P/L' },
                { key: 'EQUITY', value: 'Equity' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4SeregatedReport.js